import * as Sentry from "@sentry/nextjs";

import type { ErrorOptions, MessageOptions, SeverityLevel } from "../types";

// Map our generic severity levels to Sentry's
export const mapSeverityLevel = (
  level?: SeverityLevel
): Sentry.SeverityLevel | undefined => {
  if (!level) return undefined;
  switch (level) {
    case "debug":
      return "debug";
    case "info":
      return "info";
    case "warning":
      return "warning";
    case "error":
      return "error";
    case "fatal":
      return "fatal";
    default:
      return "info";
  }
};

/**
 * Capture an exception with Sentry
 */
export const captureException = (
  error: Error,
  options?: ErrorOptions
): string => {
  return Sentry.captureException(error, {
    level: mapSeverityLevel(options?.level),
    extra: options?.extra,
    tags: options?.tags,
    user: options?.user,
    fingerprint: options?.fingerprint
  });
};

/**
 * Capture a message with Sentry
 */
export const captureMessage = (
  message: string,
  options?: MessageOptions
): string => {
  return Sentry.captureMessage(message, {
    level: mapSeverityLevel(options?.level),
    extra: options?.extra,
    tags: options?.tags,
    user: options?.user,
    fingerprint: options?.fingerprint
  });
};

/**
 * Capture request errors with Sentry
 */
export const captureRequestError = (
  error: Error,
  request: any,
  errorContext?: any
): void => {
  Sentry.captureRequestError(error, request, errorContext);
};

/**
 * Initialize Sentry
 */
export const init = (config: any): void => {
  Sentry.init(config);
};

/**
 * Placeholder for router transition start handler
 * This function is deprecated in newer Sentry versions
 */
export const captureRouterTransitionStart = () => {};
